export class ParametersGlobals {

    static defaultHourStart: string = "0800";
    static defaultHourEnd: string = "1620";
    static defaultHourInterval: string = "0100";
    static defaultHourAmountJourney: string = "0720";
    static defaultFinancialGroupErrorID: number = 5;
    static defaultRHGroupErrorID: number = 4;
}